import React from "react";
import PropTypes from "prop-types";
import { usePhotoCapture } from "../../hooks/usePhotoCapture";
import PhotoCaptureView from "./PhotoCaptureView";

export default function PhotoCapture({ userID, uniqueKey, onDone, onPhotoDone }) {
  const {
    loading, status, errorMsg, cameraOpen, scanAddress, capturedImagePreview, confidenceResult,
    fileInputRef, videoRef, canvasRef,
    openPicker, captureFromCamera, stopCamera, handleUploadPhoto, handleFileSelect,
    callDoneCallback, handleTryAgain
  } = usePhotoCapture(userID, uniqueKey, onDone, onPhotoDone);

  return (
    <PhotoCaptureView
      loading={loading}
      status={status}
      errorMsg={errorMsg}
      cameraOpen={cameraOpen}
      scanAddress={scanAddress}
      capturedImagePreview={capturedImagePreview}
      confidenceResult={confidenceResult}
      
      fileInputRef={fileInputRef}
      videoRef={videoRef}
      canvasRef={canvasRef}
      
      onFileSelect={handleFileSelect}
      onCaptureFromCamera={captureFromCamera}
      onStopCamera={stopCamera}
      onUploadPhoto={handleUploadPhoto}
      onOpenPicker={openPicker}
      onDone={callDoneCallback}
      onTryAgain={handleTryAgain}
    />
  );
}

PhotoCapture.propTypes = {
  userID: PropTypes.string.isRequired,
  uniqueKey: PropTypes.string.isRequired,
  onDone: PropTypes.func,
  onPhotoDone: PropTypes.func,
};
